export default __webpack_public_path__ + "96e9a6cd0a451ba08f9c87ccd7e132af.png";